var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.productType === _vm.$enum.product.ProductTypeMap.PRODUCT ? _c('add-edit-copy-product', {
    attrs: {
      "type": "add"
    },
    on: {
      "product-type-change": _vm.handleProductTypeChange
    }
  }) : _c('add-edit-copy-packaging', {
    attrs: {
      "type": "add"
    },
    on: {
      "product-type-change": _vm.handleProductTypeChange
    }
  });
};

var staticRenderFns = [];
export { render, staticRenderFns };